import styles from './PersonalData.module.css'

import imPrivacy from '../../Img/PD/privacy.png'
import {SimCardUnitInt} from "../SelectNumber/SelectNumber";
import React, {useEffect, useRef, useState} from "react";
import test from '../../Img/capture.png'
import WaitLoader from "../../WaitLoader/WaitLoader";
import useFormValidator, {FormValidatorInt} from "../../FormValidator/FormValidator";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setOrderData} from "../../Reducer/GlobalReducer";
import useLongTask, {LongTaskItemCbInt} from "../../Util/LongTaskItem/UseLongTask";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import SignatureCanvas from "react-signature-canvas";
import {useIsMobile} from "../../Util/CheckMobile";
import useWindowSize from "../../Hook/UseWindowSize";
export interface PersonalDataInt
{
    orderId:string
    sessionId:string
    family:string;
    name:string;
    middleName:string;
    birthDate?:string;

    type:"RU"|"FOREIGN";
    serial:string;
    number:string;
    depart:string;

    departText?:string;
    docDate: string;

    capt: string;
    valid:boolean;
    signBase64:string


}

interface NextButtonCallBackInt
{
    (data:PersonalDataInt | undefined):void
}
interface PersonalDataPropsInt
{
    cbExecute: NextButtonCallBackInt
}

export default function RuPersonalData({cbExecute}:PersonalDataPropsInt)
{
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })
    const refSign = useRef<SignatureCanvas>(null)
    const isMobile = useIsMobile()


    const mainCont = useRef<HTMLDivElement>(null)
    const [ldrNewDkpTask, exNewDkpTask] = useLongTask(40,5000, (state, data, code,cnt)=>onNewDkpTaskTick(state, data,code,cnt),(state, data, code,cnt)=>onNewDkpTaskTick(state, data,code,cnt))

    const dispatch = useDispatch()
    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const refState = useRef<ErrorLineItemRef>(null)

    const dataTaskDoc = useRef({
        rayId:""
    })
    const [ldrTaskDoc,rsTaskDoc,exTaskDoc] = useApiQuery("/task/result","post",dataTaskDoc);
    const [checkTaskCount, setCheckTaskCount] = useState(0)

    const [stage, setStage] = useState(0)

    const [mode, setMode] = useState(0)

    const [width] = useWindowSize();

    const canvasX = width < 400 ?  250: 250


    const pdData = useRef<PersonalDataInt>()
    const [ldrPdData,rsPdData,exPdData] = useApiQuery("/sell/sim/document/check","post",pdData);

    const dataCapt = useRef({
        name: "pData",
        len:4,
        useDigit: true
    })
    const [ldrDataCapt,rsDataItemCapt,executeLoadDataCapt] = useApiQuery("/auth/capt","post",dataCapt);
    const [capt,setCap]=useState("")


    const [lockForm, setLockForm] = useState(false)
    const [acceptPd, setAcceptPd]= useState(false)


    const [reason, setReason] = useState("")


    const normFio = (val: string)=>{
        return String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase();
    }
    const normDepart = (val: string)=>{
        const pl = val.replace(/[^0-9]/ui,'')
        if(pl?.match(/^[0-9]{6}$/ui))  {
            const x = `${pl.substring(0,3)}-${pl.substring(3,6)}`
            console.log("depart2 ", x)
            return x

        }
        return val
    }

    const normDate = (val: string)=>{
        if(val?.match(/^[0-9]{8}$/ui))
            return val.substring(0,2) + "." + val.substring(2,4) + "." + val.substring(4,8)
        if(val?.match(/^[0-9]{2}.[0-9]{2}.[0-9]{4}$/ui))
            return val.substring(0,2) + "." + val.substring(3,5) + "." + val.substring(6,10)
        return val
    }


    const [formData,setFormData]=useState<FormValidatorInt[]>([
        {
            val:"",
            id:"family",
            errText: "Не корректная фамилия",
            regExp: /^[а-яё]+[ёа-я-\s]+$/ui,
            isCheck: true,
            valid: true,
            normalize: normFio,
        },
        {
            val:"",
            id:"name",
            errText: "Не корректное имя",
            regExp: /^[а-яё]+[ёа-я-\s]+$/ui,
            isCheck: true,
            valid: true,
            normalize: normFio,

        },
        {
            val:"",
            id:"middleName",
            errText: "Не корректное отчество",
            regExp: /(^[а-яё]+[ёа-я-\s]+$)|(^$)/ui,
            isCheck: true,
            valid: true,
            normalize: normFio,

        },
        {
            val:"",
            id:"birthDay",
            errText: "Не корректная дата рождения",
            regExp: /^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui,
            isCheck: true,
            valid: true,
            normalize: normDate,

        },

        {
            val:"",
            id:"serial",
            errText: "Не корректная серия паспорта",
            regExp: /^[0-9]{4}$/ui,
            isCheck: true,
            valid: true
        },

        {
            val:"",
            id:"number",
            errText: "Не корректный номер паспорта",
            regExp: /^[0-9]{6}$/ui,
            isCheck: true,
            valid: true
        },
        {
            val:"",
            id:"depart",
            errText: "Не корректный код департамента",
            regExp: /^([0-9]{6})|([0-9]{3}-[0-9]{3})$/ui,
            isCheck: true,
            valid: true,
            normalize: normDepart,

        },

        {
            val:"",
            id:"date",
            errText: "Не корректная дата выдачи",
            regExp: /^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui,
            isCheck: true,
            valid: true,
            normalize: normDate,

        },
        {
            val:"",
            id:"capt",
            errText: "Не корректный код с картинки",
            regExp: /^[a-z0-9]{4,}$/ui,
            isCheck: true,
            valid: true
        },



    ])
    const [validate,validateById,getValue,setValue,getErrText] = useFormValidator(formData)

    const loadNewCapt= ()=>
    {
        executeLoadDataCapt().then((e)=>{
            if(e?.success)setCap(e?.payload)
        })

    }


    const onNewDkpTaskTick:LongTaskItemCbInt= (state,data,code,cnt) =>
    {
        console.log(`cb state: ${state} code ${code}`, data)
        setCheckTaskCount((prevState)=>prevState+1)
        if(!state && code === 1)
        {
            setStage(4)//timeout
            return;
        }
        if(state)
        {
            const validType = data?.validType
            const validCode = data?.stateCode
            setReason(data?.errorAsString)
            if(! validType || typeof validType !== "string" || validCode === undefined)
            {
                setStage(5)
                return;
            }
            if(validType.match(/^valid/ui))
            {
                setStage(2)
                return;
            }
            if(validType.match(/^invalid/ui) && validCode === 1)
            {
                setStage(3)
                return;
            }
            if(validType.match(/^invalid/ui) && validCode === 3)
            {
                setStage(4)
                return;
            }
            if(validType.match(/^invalid/ui) && validCode === 6)
            {
                setStage(6)
                return;
            }

            setStage(5)

        }

    }

    useEffect(()=>{
        if(mainCont.current)mainCont.current.scrollIntoView()

    },[dataCapt])

    useEffect(()=>{
        switch (stage)
        {
            case 0://start
                setCheckTaskCount(0)
                setLockForm(false)
                break
            case 1://process validate
                setLockForm(true)
                if(refState.current)refState.current.clear()

                break
            case 2://ok valid
                setCheckTaskCount(0)
                //setLockForm(false)
                if(refState.current)refState.current.show("МВД : Документ действителен",false,0)
                if(pdData.current)pdData.current.valid = true
                dispatch(setOrderData({...orderData,personalData:{
                        isCorrect: true,
                        isPresent: true
                    }}))

                setTimeout(()=>{
                    if(cbExecute)cbExecute(undefined)
                },2000)

                break
            case 3://ok not valid
                if(refState.current)refState.current.show(`МВД : ${reason ? reason : "Документ не действителен"}`,true,0)
                setStage(0)
                break
            case 4:// timeout
                if(refState.current)refState.current.show("Превышено время ожидания, попробуйте позже",true,5000)
                setStage(0)
                break
            case 5:// bad data
                if(refState.current)refState.current.show("Не корректные данные с сервера, попробуйте еще раз",true,3000)
                setStage(0)
                break
            case 6:// bad data
                if(refState.current)refState.current.show("Не корректные данные паспотра, проверьте корректность",true,3000)
                setStage(0)
                break
            default:
                setCheckTaskCount(0)
                setLockForm(false)
        }
    },[stage])

    useEffect(()=>{
        loadNewCapt()
    },[dataCapt])

    const handleSend = () =>{
        if(!validate()){
            if(refState.current) refState.current.show("Исправьте поля, помеченные красным", true, 4000)
            return

        }
        if(refState.current) refState.current.clear()
        //if(errorLineRef.current)errorLineRef.current.show("",true,100)
        if(refSign.current && refState.current)
        {
            const data = refSign.current.toData()
            const len = data?.reduce((acc,item)=>{
                if(item?.length)acc+=item?.length
                return acc
            },0)
            if(len < 30 ){
                refState.current.show("Подпись слишком короткая, распишитесь крупнее",true,3000)
                refSign.current.clear()
                return;

            }
        }


        pdData.current = {
            orderId: orderData?.orderId ? orderData?.orderId : "-1",
            sessionId: orderData?.sessionId ? orderData?.sessionId : "-1",
            family: getValue("family")?.trim(),
            name: getValue("name")?.trim(),
            middleName: getValue("middleName")?.trim(),
            birthDate : getValue("birthDay")?.trim(),
            type: "RU",
            serial: getValue("serial")?.trim(),
            number: getValue("number")?.trim(),
            depart: getValue("depart")?.trim()?.replace(/[^0-9]/ui,''),
            docDate: getValue("date")?.trim(),
            capt: getValue("capt")?.trim(),
            valid: false,
            signBase64: refSign?.current ? refSign?.current.toDataURL("image/png") : ""
        }
        console.log(pdData.current)
        setStage(1)
        exPdData().then((e)=>{
            loadNewCapt()
            if(e?.success && e?.payload)
            {
                exNewDkpTask(e?.payload)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)
            setStage(0)
        }).catch((e)=>{
            if(refState.current)refState.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)
            loadNewCapt()
            setStage(0)
        })



    }


    const signText = isMobile ? "Подпись (распишитесь в рамке)" : "Подпись (зажмите левую клавишу)"


    const buildMain = () =>{
        return (
            <>
                <div className={styles.secForm}>
                    <div className={styles.secTitle}>Вы находитесь в защищенном фрейме, данные шифруются и передаются напрямую оператору</div>
                    <div className={styles.formView}>
                        <form >
                            <div className="row  ">
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Фамилия</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"Фамилия"}
                                           value={getValue("family")}
                                           onBlur={()=>validateById("family")}
                                           onChange={(e)=>setValue("family",e.target.value)}
                                           maxLength={30}
                                           readOnly={lockForm}
                                    >
                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("family")}</div>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Имя</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"Имя"}
                                           value={getValue("name")}
                                           onBlur={()=>validateById("name")}
                                           onChange={(e)=>setValue("name",e.target.value)}
                                           maxLength={30}
                                           readOnly={lockForm}
                                    >

                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("name")}</div>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Отчество</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"Отчество"}
                                           value={getValue("middleName")}
                                           onBlur={()=>validateById("middleName")}
                                           onChange={(e)=>setValue("middleName",e.target.value)}
                                           maxLength={40}
                                           readOnly={lockForm}
                                    >

                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("middleName")}</div>
                                </div>
                            </div>

                            <div className="row  ">
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Дата рождения</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"XX.XX.XXXX"}
                                           value={getValue("birthDay")}
                                           onBlur={()=>validateById("birthDay")}
                                           onChange={(e)=>setValue("birthDay",e.target.value)}
                                           maxLength={10}
                                           inputMode={"numeric"}
                                           readOnly={lockForm}
                                    >

                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("birthDay")}</div>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Серия паспорта</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"XXXX"}
                                           value={getValue("serial")}
                                           onBlur={()=>validateById("serial")}
                                           onChange={(e)=>setValue("serial",e.target.value)}
                                           maxLength={4}
                                           inputMode={"numeric"}
                                           readOnly={lockForm}
                                    >

                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("serial")}</div>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Номер паспорта</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"XXXXXX"}
                                           value={getValue("number")}
                                           onBlur={()=>validateById("number")}
                                           onChange={(e)=>setValue("number",e.target.value)}
                                           maxLength={6}
                                           inputMode={"numeric"}
                                           readOnly={lockForm}

                                    >

                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("number")}</div>
                                </div>
                            </div>


                            <div className="row  ">
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Дата выдачи</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"XX.XX.XXXX"}
                                           value={getValue("date")}
                                           onBlur={()=>validateById("date")}
                                           onChange={(e)=>setValue("date",e.target.value)}
                                           maxLength={10}
                                           inputMode={"numeric"}
                                           readOnly={lockForm}

                                    >

                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("date")}</div>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Код подразделения</label>
                                    <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"XXX-XXX"}
                                           value={getValue("depart")}
                                           onBlur={()=>validateById("depart")}
                                           onChange={(e)=>setValue("depart",e.target.value)}
                                           maxLength={9}
                                           inputMode={"numeric"}
                                           readOnly={lockForm}

                                    >

                                    </input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("depart")}</div>
                                </div>
                                <div className={["col-md-4 d-none d-md-flex", styles.blPriv].join(' ')}>
                                    <img src={imPrivacy} alt={"Приватность"}/>
                                </div>

                            </div>

                            <div className={"row"}>
                                <div className={styles.cpCont}>
                                    <div className={styles.sgBlock}>
                                            <div className={styles.signTitle}>{signText}</div>
                                            <div className={styles.signCont}>
                                                <div className={styles.canvasCont}>
                                                    <SignatureCanvas
                                                        ref={refSign}
                                                        penColor='black'
                                                        canvasProps={{width: canvasX, height: 200, className: styles.sigCanvas} }
                                                    />
                                                    <div className={styles.signBtn}>
                                                        <button type="button" className="btn btn-face"
                                                                onClick={()=>{
                                                                    if(refSign.current) {
                                                                        console.log(refSign.current.toDataURL('image/png'))
                                                                        refSign.current.clear()
                                                                    }
                                                                }}
                                                        >Очистить</button>

                                                    </div>
                                                </div>

                                            </div>

                                    </div>
                                    <div className={styles.imBlock}>
                                        <div className={styles.imItem}>
                                            <div className={styles.imTitle}>Проверочный код</div>
                                            <div className={styles.rfCont}>
                                                <i className={['bx bx-refresh'  ].join(' ')} onClick={()=>{loadNewCapt() }}></i>
                                            </div>


                                            <div className={styles.ciBlock}>
                                                <div className={styles.imCont}>
                                                    <img src={capt} onClick={()=>{loadNewCapt() }}/>
                                                </div>
                                                <input type="text" className="form-control" placeholder={"XXXX"}
                                                       value={getValue("capt")}
                                                       inputMode={"numeric"}
                                                       onBlur={()=>validateById("capt")}
                                                       onChange={(e)=>setValue("capt",e.target.value)}
                                                       maxLength={4}
                                                />

                                            </div>

                                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("capt")}</div>


                                        </div>







                                    </div>

                                </div>
                            </div>






                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="checkbox" id="inlineCheckbox1"
                                       checked={acceptPd}
                                       onChange={()=>setAcceptPd(!acceptPd)}
                                       style={{cursor:"pointer"}}
                                />
                                <label className="form-check-label" htmlFor="inlineCheckbox1" style={{cursor:"pointer"}}>Даю согласие на обработку данных</label>
                            </div>



                            <ErrorLineItem ref={refState} ></ErrorLineItem>


                            <div className={"row my-2"}>
                                <div className="col-12">
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-face"
                                                disabled={!acceptPd || stage===1 || stage ===2}
                                                onClick={()=>handleSend()}
                                        >Отправить</button>
                                        <WaitLoader loading={ldrPdData} api={rsPdData} onlyLoading={true} >
                                            <div className={styles.checkRs}>
                                                {stage === 1 && <div className={styles.wCheck}>{`Идет проверка ${checkTaskCount}`}</div>}
                                            </div>
                                        </WaitLoader>

                                    </div>

                                </div>

                            </div>





                        </form>
                    </div>
                </div>
            </>

        )
    }



    return(
        <div className={styles.pdCont} ref={mainCont}>
            <p className={styles.pdTitle}>
                Согласно Федеральному Закону “О связи” 126-ФЗ, SIM карта оформляется на данные паспорта  гражданина  Российский Федерации. Для оформления заказа необходимо заполнить форму, ознакомиться с политикой использования персональных данных по ссылке, дать согласие на обработку персональных данных.
                Проверка данных на корректность осуществляется с помощью системы СМЭВ. Политика использования персональных данных<a href={baseUrl + '/static/ppd-politic.docx'} target={"_blank"}>скачать</a>

            </p>

            {buildMain()}


        </div>
    )
}